export const RecoveringActionTypes = {
  SetRecoveredTranscriptionFile: "RECOVERING_SET_RECOVERED_TRANSCRIPTION_FILE",
  SetRecoveryFlowCancelDialog: "RECOVERING_SET_RECOVERY_FLOW_CANCEL_DIALOG"
};